<!-- 头部 -->
<template>
  <div class="section_tou flex-col justify-end">
    <div class="group_47 flex-row clearfix">
      <div class="section_3 leftfix">
        <img style="height: 60px" src="../../../static/img/LOGO.png" alt="" />
      </div>
      <div v-for="(item, index) in navList" :key="index" class="text rightfix">
        <router-link :to="item.url" class="text-wrapper_29">
          <span class="text_3" @click="handleClick(item.url)">{{
            item.name
          }}</span>
          <span class="text_4" @click="handleClick(item.url)">{{
            item.name_
          }}</span>
        </router-link>
        <!-- <div class="section_4 flex-col"></div> -->
        <div
          class="image-wrapper_11 flex-row"
          :style="stylt_"
          v-if="item.url == currentNav"
        ></div>
      </div>
      <div class="buts">
        <img
          style="width: 70px;margin: 15px 0 0 15px;"
          referrerpolicy="no-referrer"
          src="@/assets/img/top_logo@1x.png"
          @click="gotoblibli"
        />
      </div>
      <div class="buts">
        <img
          style="width: 70px;margin: 15px 0 0 15px;"
          referrerpolicy="no-referrer"
          src="@/assets/img/xhs.png"
          @click="gotoxhs"
        />
      </div>
    </div>
  </div>
</template>

<script>
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?ec220e97268759013846786e2dc205d6";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
export default {
  data() {
    return {
      navList: [
        { url: "/index", name: "首页", name_: "ホーム" },
        { url: "/schoolCommon", name: "学校信息库", name_: "学校データ" },
        { url: "/answers", name: "学校信息比对", name_: "学校情報" },
        { url: "/study", name: "留学资讯", name_: "留学ニュース" },
        { url: "/life", name: "留学生活", name_: "留学情報" },
        { url: "/regard", name: "关于我们", name_: "お問い合わせ" }
      ],
      currentNav: "", // 跟踪当前菜单
      stylt_: "margin-left: 20px"
    };
  },
  mounted() {
    this.currentNav = "/" + this.$route.name;
    if (this.currentNav == "/index") {
      this.stylt_ = "margin-left: 20px";
    } else if (this.currentNav == "/schoolCommon") {
      this.stylt_ = "margin-left:60px";
    } else if (this.currentNav == "/study") {
      this.stylt_ = "margin-left:60px";
    } else if (this.currentNav == "/answers") {
      this.stylt_ = "margin-left:60px";
    } else if (this.currentNav == "/life") {
      this.stylt_ = "margin-left:40px";
    } else if (this.currentNav == "/regard") {
      this.stylt_ = "margin-left:60px";
    }
  },
  methods: {
    // flusgCom() {
    //   this.$route.go(0);
    // },   
     gotoblibli() {
      window.open(
        "https://space.bilibili.com/3546692269902327?plat_id=1&share_from=space&share_medium=iphone&share_plat=ios&share_session_id=5DAF3541-3250-42CC-83CD-EBADE9679092&share_source=WEIXIN&share_tag=s_i&spmid=main.space-contribution.0.0&timestamp=1721096842&unique_k=7OBS83F"
      );
    },
    gotoxhs() {
      window.open(
        "https://www.xiaohongshu.com/user/profile/644df0e5000000002a0087fb?xhsshare=WeixinSession&appuid=644df0e5000000002a0087fb&apptime=1721365542&share_id=2fd2a0fe68af44a4a2d2b1d458a5ec71&wechatWid=feea6e33a775c9669527e67ae5338798&wechatOrigin=menu"
      );
    },
    handleClick(nav) {
      this.currentNav = nav;
      //   if (this.currentNav == "/index") {
      //     to.meta.keepAlive = false;

      //     // this.stylt_ = "margin: 7px 0 0 720px;";
      //   } else if (this.currentNav == "/schoolCommon") {
      //     to.meta.keepAlive = false;
      //     // this.stylt_ = "margin: 7px 0 0 884px";
      //   } else if (this.currentNav == "/study") {
      //     to.meta.keepAlive = false;
      //     // this.stylt_ = "margin: 7px 0 0 1065px";
      //   } else if (this.currentNav == "/answers") {
      //     to.meta.keepAlive = false;
      //     // this.stylt_ = "margin: 7px 0 0 1240px";
      //   } else if (this.currentNav == "/consult") {
      //     to.meta.keepAlive = false;
      //     // this.stylt_ = "margin: 7px 0 0 1410px";
      //   } else if (this.currentNav == "/regard") {
      //     to.meta.keepAlive = false;
      //     // this.stylt_ = "margin: 7px 0 0 1573px";
      //   }
    }
  }
};
</script>

<style scoped>
.image_1 {
  width: 38px;
  height: 18px;
}

.image-wrapper_11 {
  width: 38px;
  height: 18px;
  /* margin: 7px 0 0 766px; */
}
.group_47 {
  width: 1350px;
  height: 78px;
  margin: 0 auto;
  /* margin: 28px 0 0 360px; */
}

.section_3 {
  /* background: url("../../../static/img/logo.jpg"); */
  width: 390px;
  height: 60px;
  background-repeat: no-repeat;
}

.text_3 {
  width: 115px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(34, 34, 34, 0.8);
  font-size: 20px;
  /*font-family:microsoftyahei,"微软雅黑",SourceHanSansCN-Regular;
  font-weight: NaN; */
  text-align: center;
  white-space: nowrap;
  line-height: 30px;
  margin-right: 5px;
  display: inline-block;
}
/* .section_text{
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 50px;
  border: 1px solid red;
  margin-left: 10px;
  margin-top: 5px;
} */
.text {
  border-right: 1px solid #f0f0f0;
  /* 鼠标移上去显示手指 */
  cursor: pointer;
  margin-top: 10px;
}
.text_4 {
  width: 90px;
  height: 10px;
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 10px;
  text-transform: uppercase;
  font-family: microsoftyahei, "微软雅黑", SourceHanSansCN-Regular;
  font-weight: NaN;
  text-align: right;
  white-space: nowrap;
  line-height: 15px;
  /* margin: 10px 0 0 4px; */
}
.section_4 {
  background-color: rgba(240, 240, 240, 1);
  width: 1px;
  height: 60px;
  margin-left: 30px;
}

.text-wrapper_29 {
  width: 100px;
  height: 80px;
  text-decoration: none;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}

.justify-between {
  display: flex;
  justify-content: space-between;
}

.section_tou {
  background-color: rgba(255, 255, 255, 1);
  height: 95px;
  /* width: 1920px; */
  margin: 0 auto;
}

.nav-bar {
  display: flex;
  justify-content: center;
  /* 水平居中 */
  background-color: #0b6cb8;
  height: 50px;
  position: relative;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}

li {
  font-size: 16px;
  color: #fff;
  padding: 15px 2px;
}

li a {
  font-size: 16px;
  color: #fff;
  padding: 15px 15px;
  text-decoration: none;
}

li:hover {
  background-color: rgb(0, 140, 255);
}

.sub-menu {
  position: absolute;
  padding-top: 15px;
  z-index: 999;
}

.twolist {
  display: flex;
  flex-direction: column;
  /* 添加这一行 */
  background-color: #0b6cb8;
  display: none;
  margin-left: -10px;
}

.nav-bar > ul > li:hover ul {
  display: block;
}

.leftfix {
  float: left;
}

.rightfix {
  float: right;
}
/* 清除浮动 */
.clearfix::after {
  content: "";
  display: block;
  clear: both;
}
.buts{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/navbar.vue